import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { PershingTranslationService } from '@pershing/pershing-core';

@Component({
    selector: 'outstandamount',
    templateUrl: './outstandamount.component.html'
})
export class OutStandAmountComponent implements OnInit {

    @Input() mortgagesData: any;
    @Input() loanAdvanceData: any;
    localmortgagesData: any;
    expandedElement: any;
    asofdate: any;
    availableOutstanding: any;
    availableCreditLimit: any;
    localLoanAdvanceData: any;
    finalAvaialbleCredit: any;
    finalAvailOutStd: any;
    availableCredit: any;
    currentBalance: any;
    asOfDateString: any;
    constructor(
        private translationService: PershingTranslationService
    ) {
    }

    ngOnInit() {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-balances', 'node_modules/@pershing/nxi-ng-balances/lib');
        this.addTotalAmount();
    }
    ngOnChanges() {
        this.addTotalAmount();
    }
    addTotalAmount(): void {
        this.localmortgagesData = this.mortgagesData;
        this.localLoanAdvanceData = this.loanAdvanceData;
        if(this.localLoanAdvanceData !== undefined && this.localLoanAdvanceData !== 'undefined') {
            let formatAvailableCredit = this.localLoanAdvanceData.totalAvailCredit;
            this.finalAvaialbleCredit = formatAvailableCredit.replace(/,/g, '');
            let formatAvailOutStand = this.localLoanAdvanceData.totalOutstanding;
            this.finalAvailOutStd = formatAvailOutStand.replace(/,/g, '');
        }else {
            this.finalAvaialbleCredit = '0';
            this.finalAvailOutStd = '0';
        }
        if(this.localmortgagesData !== undefined && this.localmortgagesData !== 'undefined'){
            this.availableCredit = this.localmortgagesData.availableCredit;
            this.currentBalance = this.localmortgagesData.currentBalance;
            this.asOfDateString = this.localmortgagesData.asOfDateString;
        } else {
            this.availableCredit = 0;
            this.currentBalance = 0;
        }
        this.asofdate = this.asOfDateString;
        this.availableCreditLimit = this.availableCredit+ +this.finalAvaialbleCredit;
        this.availableOutstanding =  this.currentBalance+ +this.finalAvailOutStd;
    }
}
